import { gql } from '@apollo/client';
import ORDER_ITEM_FRAGMENT from './order-item';

const BASE_MASTERCODE_FRAGMENT = gql`
  fragment BaseMastercodeFragment on Mastercode {
    id
    code
    ownerEmail
    dateGracePeriodEnd
    dateScheduledUnlock
    dateUnlocked
    dateExpired
    dateCreated
  }
`;

const MASTERCODE_FRAGMENT = gql`
  fragment MastercodeFragment on Mastercode {
    ...BaseMastercodeFragment
    parentMastercode {
      ...BaseMastercodeFragment
    }
    orderItems {
      ...BaseOrderItem
    }
  }
  ${BASE_MASTERCODE_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;

export default MASTERCODE_FRAGMENT;
